<template>
  <div class="customFunnel-wrap">
    <div class="content">
      <div
        v-for="(item, index) of textRow"
        :key="index"
        class="common"
        :class="`funnel-item${index + 1}`"
        :style="[
          {
            'width': `calc(90% - (${2 * index + 1}vw))`,
            'paddingBottom': config.gap + 'px',
            'borderTop': `${config.itemHeight}px solid ${config.bgColor}`
          }
        ]"
      >
        <div
          class="txt"
          :style="{
            'fontSize': config.text.size + 'px',
            'color': config.text.color,
            'lineHeight': config.itemHeight + 'px',
            'height': config.itemHeight + 'px',
            'bottom': `calc(50% + ${config.gap / 2}px)`
          }"
        >
          <div
            v-if="config.text.label"
            :style="[config.text.value ? {'lineHeight': config.itemHeight / 2 + 'px'} : '']"
          >
            {{ item.label }}
          </div>
          <div
            v-if="config.text.value"
            :style="[config.text.label ? {'lineHeight': config.itemHeight / 2 + 'px'} : '']"
          >
            <!-- {{ $cUtils.format.fillNumber(chartData[0][item.value], 3, ',') }}{{ config.text.company }} -->
            {{ format_number(chartData[0][item.value]) }}{{ config.text.company }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CustomFunnel',
  props: {
    config: {
      type: Object,
      default () {
        return {}
      }
    },
    chartData: {
      type: Array,
      default () {
        return []
      }
    }
  },
  computed: {
    textRow () {
      let temp = this.config.textRow
      temp = temp.map(item => {
        return {
          label: item.children[0].value,
          value: item.children[1].value
        }
      })
      return temp
    }
  },
  methods: {
    format_number (n) {
      if (n) {
        n = n.toString()
        var len = n.length
        if (len <= 3) { return n }
        var r = len % 3
        const start = n.slice(0, r)
        const end = n.slice(r).match(/\d{3}/g).join(',')
        return r > 0 ? start + ',' + end : end
      } else {
        return n
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.customFunnel-wrap
  display flex
  justify-content center
  align-items center
  height 100%
  .content
    width 100%
    .common
      position relative
      height 0
      border-left 1vw solid transparent
      border-right 1vw solid transparent
      box-sizing border-box
      text-align center
      margin 0 auto
      &:last-child
        padding-bottom 0
      .txt
        position absolute
        left 0
        right 0
</style>
